import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import DataTableRepository from '../Repositories/DataTableRepository'

class DataTableBloc {

    rowtableChannel = new Subject();
    generateChannel = new Subject();
    rowtableUnprocessChannel = new Subject();
    inactiveChannel = new Subject();
    inactiveSKChannel = new Subject();
    repository = new DataTableRepository()

    constructor() {
        this.rowtableChannel.next({status: apiResponse.INITIAL})
        this.generateChannel.next({status: apiResponse.INITIAL})
        this.rowtableUnprocessChannel.next({status: apiResponse.INITIAL})
        this.inactiveChannel.next({status: apiResponse.INITIAL})
        this.inactiveSKChannel.next({status: apiResponse.INITIAL})
        
    }

    fetchRowTable = async (query, cancelToken) => {
        try {
            this.rowtableChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchRowTable(query, cancelToken).then((result) => {
                this.rowtableChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.rowtableChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { console.log('unsubscribed') }
    }
    fetchGenerateTable = async (query, cancelToken) => {
        try {
            this.generateChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchGenerateTable(query, cancelToken).then((result) => {
                this.generateChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.generateChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { console.log('unsubscribed') }
    }
    fetchRowTableManual = async (query, cancelToken) => {
        try {
            this.rowtableChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchRowTableManual(query, cancelToken).then((result) => {
                this.rowtableChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.rowtableChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { console.log('unsubscribed') }
    }
    fetchRowTableunprocess = async (query, cancelToken) => {
        try {
            this.rowtableUnprocessChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchRowTableunprocess(query, cancelToken).then((result) => {
                this.rowtableUnprocessChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.rowtableUnprocessChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { console.log('unsubscribed') }
    }

    fetchInactive = async (query) => {
        try {
            this.inactiveChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchInactive(query).then((result) => {
                this.inactiveChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.inactiveChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { console.log('unsubscribed') }
    }
    fetchInactiveSK = async (query) => {
        try {
            this.inactiveSKChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchInactiveSK(query).then((result) => {
                this.inactiveSKChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.inactiveSKChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { console.log('unsubscribed') }
    }

}

export default DataTableBloc